import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import { APP_HEIGHT } from "@/app/layout.utils";

interface PageProps {
  isLocked?: boolean;
  children: ReactNode;
}

/**
 * Every page's frame: a PageHeader, then the content. By default the window scrolls the page;
 * `isLocked` makes it exactly the window's height, with the part after the header scrolling inside.
 *
 *   <Page isLocked>
 *     <PageHeader title="Inventory" />
 *     <ListGrid …>…</ListGrid>
 *   </Page>
 */
export const Page = (props: PageProps) => {
  const { isLocked = false, children } = props;

  let height: string | undefined;
  if (isLocked) height = APP_HEIGHT;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height,
        pb: isLocked ? 0 : 3,
      }}
    >
      {children}
    </Box>
  );
};
